<template>
    <div id="receipt_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="ReceiptHeader" v-if="$route.params.id > 0">Update Receipt</span>
                    <span class="page-title" id="ReceiptHeader" v-else>Add Receipt</span>
                    <button type="submit" class="btn btn-secondary pull-right " v-on:click.prevent="BackReceiptList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="ReceiptForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <!-- <div class="col form-group mt-3">
                                        <label for="receipt_number">Receipt Number: </label>
                                        <span class="label font-semibold">{{receipt_number}}</span>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="receipt_date">Receipt Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="receipt_date" name="receipt_date" v-model="receipt_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="receipt_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{receipt_date_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="deposit_date">Deposit Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="deposit_date" name="deposit_date" v-model="deposit_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="deposit_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{deposit_date_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="deposit_date">Bank Code:</label>
                                        <v-select v-model="bank_code" placeholder="Select Bank."
                                                label="text"
                                                :options="bankArr" class="close-remove">
                                        </v-select>
                                        <div class="field-error">{{bank_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="receipt_number">Account Number:</label>
                                        <input type="text" class="form-control" v-model="account_number" id="account_number" placeholder="Enter Account Number" name="account_number">
                                        <div class="field-error">{{account_number_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="receipt_number">Account Name:</label>
                                        <input type="text" class="form-control" v-model="account_name" id="account_name" placeholder="Enter Account Name" name="account_name">
                                        <div class="field-error">{{account_name_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="receipt_number">Bank CC Code:</label>
                                        <input type="text" disabled class="form-control" v-model="bank_currency_code" id="bank_currency_code" placeholder="Enter Bank Currency Code" name="bank_currency_code">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Payment CC Code:</label>
                                        <input type="text" class="form-control" v-model="payment_currency_code" id="payment_currency_code" placeholder="Enter Payment Currency Code" name="payment_currency_code">
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Account Number:</label>
                                        <!-- <input type="text" class="form-control" v-model="account_number" id="account_number" placeholder="Enter Account Number" name="account_number"> -->
                                        <v-select v-model="account_number" placeholder="Select Account Number."
                                                label="text"
                                                :options="accArr" class="close-remove">
                                        </v-select>
                                        <div class="field-error">{{account_number_error_msg}}</div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="name">Bank Reference:</label>
                                        <input type="text" class="form-control" v-model="bank_reference" id="bank_reference" placeholder="Enter Bank Reference" name="bank_reference">
                                        <div class="field-error">{{bank_reference_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="name">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description"> -->
                                        <!-- <div class="field-error">{{description_error_msg}}</div> -->
                                    <!-- </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="name">Payment Number:</label>
                                        <input type="text" class="form-control" v-model="payment_number" id="payment_number" placeholder="Enter Payment Number" name="payment_number">
                                        <div class="field-error">{{payment_number_error_msg}}</div>
                                    </div> -->
                                     <!-- <div class="col form-group">
                                        <label class="control-label require" for="name">Payment Amount:</label>
                                        <input type="text" class="form-control" v-model="amount" id="amount" placeholder="Enter Payment Amount" name="amount" @keypress="isNumberKey($event)">
                                        <div class="field-error">{{amount_error_msg}}</div>
                                    </div> -->
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="name">Customer Reference:</label>
                                        <input type="text" class="form-control" v-model="customer_reference" id="customer_reference" placeholder="Enter Customer Reference" name="customer_reference">
                                        <div class="field-error">{{customer_reference_error_msg}}</div>
                                    </div> -->
                                     <div class="col form-group">
                                        <label class="control-label require" for="type">Type:</label>
                                        <v-select v-model="type" placeholder="Select Type."
                                                label="text"
                                                :options="typeArr" class="close-remove">
                                        </v-select>
                                        <div class="field-error">{{type_error_msg}}</div>
                                    </div>
                                </div>
                                <!-- <div class="form-row">
                                    <div class="col-md-4 offset-md-8">
                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                            <tr>
                                                <td class="bg-gray require valign-middle"> RCT Amount: </td>
                                                <td>
                                                    <div class="input-group w-60 pull-right">
                                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon4">$</span>
                                                        </div>
                                                        <input type="text" class="form-control text-right" v-model="receipt_amount" id="receipt_amount" @input="calculateAmount()" placeholder="Enter Receipt Amount" name="receipt_amount" @keypress="isNumberKey($event)">
                                                    </div>
                                                </td>

                                            </tr>
                                            <tr>
                                                <td class="bg-gray"> Amt Entered: </td>
                                                <td class="text-right"> ${{amount_entered.toFixed(2)}}</td>
                                            </tr>
                                            <tr>
                                                <td class="bg-gray"> Difference: </td>
                                                <td class="text-right"> ${{difference.toFixed(2)}} </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div> -->
                                <div class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require">Payment Number</th>
                                                <th scope="col">Bank Reference</th>
                                                <th scope="col">Customer Reference</th>
                                                <th scope="col" class="require">Amount</th>
                                                <th scope="col" class="require">Date</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in rows" :key="index">
                                                <!-- <td>
                                                    <input type="text" :disabled="index == 0 ? false : true" placeholder="Enter Type" v-model="row.type" name="type" id="type" class="form-control">
                                                    <div class="field-error">{{row.type_error_msg}}</div>
                                                </td> -->
                                                <td>
                                                    <input type="text" placeholder="Enter Payment Number" v-model="row.payment_number" name="payment_number" id="payment_number" class="form-control">
                                                    <div class="field-error">{{row.payment_number_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text"  placeholder="Bank Reference" v-model="row.bank_reference" name="bank_reference" id="bank_reference" class="form-control">
                                                    <div class="field-error">{{row.bank_reference_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text"  placeholder="Customer Reference" v-model="row.customer_reference" name="customer_reference" id="customer_reference" class="form-control">
                                                    <div class="field-error">{{row.customer_reference_error_msg}}</div>
                                                </td>
                                                
                                                <td>
                                                    <input type="text" placeholder="Enter Amount" v-model="row.amount" name="amount" id="amount" class="form-control text-right" @keypress="isNumberKey($event)">
                                                    <div class="field-error">{{row.amount_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <div class="form-group input-group mb-0">
                                                        <date-picker  placeholder="MM/DD/YYYY" id="payment_date" name="payment_date" v-model="row.payment_date" :config="optionsDate"></date-picker>
                                                        <label for="payment_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                    <div class="field-error">{{row.payment_date_error_msg}}</div>
                                                </td>
                                                <td>
                                                    <input type="text"  placeholder="Description" v-model="row.description" name="description" id="description" class="form-control">
                                                    <div class="field-error">{{row.description_error_msg}}</div>
                                                </td>
                                                <td class="text-center">
                                                    <template v-if="rows.length != 1">
                                                            <a href="#" v-on:click.prevent="removeElement(index);"><i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Line Item
                                    </button>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createReceiptBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateReceipt" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createReceiptBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateReceipt">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <!-- <button type="submit" v-if="!isRelease" id="createReceiptBtn" class="btn btn-secondary" v-on:click.prevent="CreateReceipt(flag = 'release')">
                                    <i class="fp-save"> </i>  Release
                                    </button> -->
                                    <button type="submit" id="createAndContinueReceiptBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateReceipt(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelReceiptBtn" class="btn btn-tertiary" v-on:click.prevent="BackReceiptList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>

                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import moment from 'moment'


export default {
  name: "ReceiptCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Receipt | " +process.env.COPYRIGHT_NAME : "Create Receipt | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    loading:false,
    receipt_amount:'',
    receipt_number:'',
    receipt_date:moment().format("MM/DD/YYYY"),
    deposit_date:moment().format("MM/DD/YYYY"),
    bank_code:'',
    bankArr:[],
    bank_currency_code:'USD',
    payment_currency_code:'USD',
    rows:[],
    bank_reference:'',
    bank_reference_error_msg:'',
    bank_error_msg:'',
    deposit_date_error_msg:'',
    receipt_date_error_msg:'',
    amount_error_msg:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    difference:0.00,
    amount_entered:0.00,
    payment_amount:'',
    isRelease:false,
    type_error_msg:'',
    type:'',
    // typeArr:[{text:'Account Receivable',value:'account_receivable'}
    // ,{text:'Account Payble',value:'account_payble'}
    // // {text:'General Account',value:'general_account'}
    // ],
    typeArr:[{text:'Deposit',value:'deposit'}
    ,{text:'Withdraw',value:'withdraw'}
    // {text:'General Account',value:'general_account'}
    ],
    accArr:[{text:'113770930' , value:'113770930'},{text:'113876880' , value:'113876880'}],
    account_name_error_msg:'',
    account_number_error_msg:'',
    account_name:'',
    account_number:'',
    customer_reference:'',
    customer_reference_error_msg:'',
    description:'',
    payment_number_error_msg:'',
    amount:'',
    payment_number:'',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_payment_receipt') {
                        self.cantAccessPage = true;
                    }
                }
            }
        },
        rows: {
            handler: function (val, oldVal) {
                console.log(val)
                var self = this;
                var amount = 0;
                var totalAmount = 0
                for (var j = 0; j < val.length; j++) {

                    if (val[j].amount != "" && val[j].amount != ".") {
                        totalAmount += parseFloat(val[j].amount);
                    }

                }
                self.amount_entered = parseFloat(totalAmount);
                if (self.receipt_amount == "") {
                    self.difference = 0 - parseFloat(self.amount_entered);
                }else{
                    self.difference = parseFloat(self.receipt_amount) - parseFloat(self.amount_entered);
                }
            },
            deep: true
        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadReceipt();
            }else{
                self.rows.push({
                    receipt_item_id: 0,
                    payment_number: '',
                    payment_number_error_msg: "",
                    // type: "",
                    // type_error_msg: "",
                    payment_date: null,
                    payment_date_error_msg: "",
                    amount: 0,
                    amount_error_msg:'',
                    bank_reference: "",
                    customer_reference:"",
                    description:"",
                    item_id:0,
                    // info: "",
                    // info_error_msg: "",
                    // app_type: '',
                    // app_type_error_msg: "",
                });

                // self.fetchReceiptNumber();
            }

        }, 100);

        // self.fetchBanks();
  },
  methods: {
    BackReceiptList() {
      var self = this;
      self.$router.push("/bank-transfer/list");
    },
    
    addRow: function () {

            var self = this;
            var index = self.rows.length - 1;
            var error = false;

            self.rows[index].payment_number_error_msg = "";
            self.rows[index].amount_error_msg = "";
            self.rows[index].type_error_msg = "";
            self.rows[index].payment_date_error_msg = "";

            if (self.rows[index].payment_number != null && self.rows[index].payment_number != '' && self.rows[index].amount &&
                self.rows[index].amount != '' && self.rows[index].amount > 0 && self.rows[index].payment_date != '' && self.rows[index].payment_date != null) {

                self.rows.push({
                    receipt_item_id: 0,
                    payment_number: '',
                    payment_number_error_msg: "",
                    payment_date: null,
                    payment_date_error_msg: "",
                    amount: 0,
                    amount_error_msg:'',
                    bank_reference: "",
                    customer_reference:"",
                    description:"",
                    receipt_number:0,
                    item_id:0
                });

            } else {
                if (self.rows[index].payment_number == null || !self.rows[index].payment_number || self.rows[index].payment_number == '') {
                    self.rows[index].payment_number_error_msg = "Payment Number is Required.";
                    error = true;
                }
                if (self.rows[index].amount == null || !self.rows[index].amount) {
                    self.rows[index].amount_error_msg = "Amount is Required.";
                    error = true;
                }
                if (self.rows[index].payment_date == null || !self.rows[index].payment_date) {
                    self.rows[index].payment_date_error_msg = "Payment Date is Required.";
                    error = true;
                }
            }
        },
        removeElement: function (index) {
            var self = this;
            if (self.rows.length > 1) {
                if (self.rows[index].receipt_item_id == 0) {
                    self.rows.splice(index, 1);
                    // self.calculateTaxSubTotal();

                } else {
                    if (confirm('Are you sure that you want to delete this Receipt Item? ')) {
                        self.bankRecDelete(index);
                    }
                }
            }
        },
        bankRecDelete:function(index){
          var self = this;
          var selectedRows = [];
            selectedRows.push(self.rows[index].item_id);
          $.ajax({
                    url: process.env.ROOT_API + "/bank-transfer/delete",
                    type: "POST",
                    data: 'id=' + selectedRows,
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                      var msg = "";
                      if(data.content.length > 0){
                        msg = "#Sequence No : "+data.content+" was skipped in deletion";
                        self.$swal("",msg,'info');
                        return;
                      }
                      self.rows.splice(index, 1);
                      return;
                    },
                    error: function (jqXHR, exception) {
                      self.loading = false;
                      self.generateStatusCodeMessage(jqXHR,false,'bank-transferlist');
                    }
                });
        },

    CreateReceipt(flag) {
        console.log("here create ");
      var self = this;

      self.receipt_date_error_msg = "";
    //   self.deposit_date_error_msg = "";
    //   self.receipt_amount_error_msg = '';
    //   self.bank_error_msg = "";
    //   self.bank_reference_error_msg = '';
    //   self.customer_reference_error_msg = '';
      self.account_number_error_msg = '';
    //   self.account_name_error_msg = '';
      self.type_error_msg = '';
    //   self.payment_number_error_msg = '';
      self.amount_error_msg = '';

      var error = false;

      if (!self.account_number.value || self.account_number == null ) {
        self.account_number_error_msg = "Account Number Required.";
        error = true;
      }
      if (self.type == null || !self.type.value){
          self.type_error_msg = 'Type Required';
          error = true;
      }

        for (var i = 0; i < self.rows.length; i++) {
            self.rows[i].payment_number_error_msg = "";
            self.rows[i].amount_error_msg = "";
            self.rows[i].payment_date_error_msg = "";

            if (self.rows[i].payment_number == null || self.rows[i].payment_number == '' || !self.rows[i].payment_number) {
                self.rows[i].payment_number_error_msg = "Payment Number is Required.";
                 error = true;
            }
            if (self.rows[i].amount == null || !self.rows[i].amount || self.rows[i].amount == '') {
                self.rows[i].amount_error_msg = "Amount is Required.";
                 error = true;
            }
            if (self.rows[i].payment_date == null || self.rows[i].payment_date == '') {
                self.rows[i].payment_date_error_msg = "Payment Date is Required.";
                 error = true;
            }
        }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createReceiptBtn").val("Updating ...");
                $("#createReceiptBtn").prop("disabled", true);
                $("#cancelReceiptBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueReceiptBtn").val("Saving ...");
                    $("#createReceiptBtn").prop("disabled", true);
                    $("#createAndContinueReceiptBtn").prop("disabled", true);
                    $("#cancelReceiptBtn").prop("disabled",true);

                }else{

                    $("#createReceiptBtn").val("Saving ...");
                    $("#createReceiptBtn").prop("disabled", true);
                    $("#createAndContinueReceiptBtn").prop("disabled", true);
                    $("#cancelReceiptBtn").prop("disabled",true);
                }

            }

            var fields = $("#ReceiptForm").serializeArray();

            // fields.push({
            //         name: "receipt_number",
            //         value: self.receipt_number
            //     });

            // fields.push({
            //         name: "bank_currency_code",
            //         value: self.bank_currency_code
            //     });

            // fields.push({
            //         name: "amount_entered",
            //         value: self.amount_entered
            //     });

            // fields.push({
            //         name: "amount",
            //         value: self.amount
            //     });

            // fields.push({
            //         name: "difference",
            //         value: self.difference
            //     });

            // fields.push({
            //         name: "bank_id",
            //         value: self.bank_code.value
            //     });
            fields.push({
                    name: "account_number",
                    value: self.account_number.value
                });
            fields.push({
                    name: "items",
                    value: JSON.stringify(self.rows)
                });

            fields.push({
                    name: "type",
                    value: self.type.value
                });

            fields.push({
                name: "receipt_number",
                value: self.receipt_number
            });
                // receipt_number
            // if (flag && flag == 'release'){
            //     fields.push({
            //         name: "release",
            //         value: 'true'
            //     });
            // }
            if (segments[3]){
                fields.push({
                        name: "id",
                        value: segments[3]
                    });
            }

            $.ajax({
                url: process.env.ROOT_API + "/bank-receipt/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createReceiptBtn").val("Update");
                        $("#createReceiptBtn").prop("disabled", false);
                        $("#cancelReceiptBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueReceiptBtn").val("Save and Continue");
                            $("#createReceiptBtn").prop("disabled", false);
                            $("#createAndContinueReceiptBtn").prop("disabled", false);
                            $("#cancelReceiptBtn").prop("disabled",false);

                        }else{

                            $("#createReceiptBtn").val("Save");
                            $("#createReceiptBtn").prop("disabled", false);
                            $("#createAndContinueReceiptBtn").prop("disabled", false);
                            $("#cancelReceiptBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#ReceiptForm").trigger("reset");
                            // self.bank_code = {text:'',value:''};
                            // self.bank_currency_code = 'USD';
                            // self.bank_currency_code = 'USD';
                            // self.receipt_date = '';
                            // self.bank_reference = '';
                            self.account_number = '';
                            self.account_number_error_msg = '';
                            // self.payment_number_error_msg = '';
                            // self.payment_number = '';
                            // self.payment_amount = '';
                            // self.amount_error_msg = '';
                            // self.customer_reference = '';
                            // self.customer_reference_error_msg = '';
                            self.type = '';
                            // self.bank_reference_error_msg = '';
                            // self.receipt_amount = 0;
                            self.rows = [];

                            self.rows.push({
                                receipt_item_id: 0,
                                payment_number: '',
                                payment_number_error_msg: "",
                                payment_date: null,
                                payment_date_error_msg: "",
                                amount: 0,
                                amount_error_msg:'',
                                bank_reference: "",
                                customer_reference:"",
                                description:"",
                                receipt_number:0,
                                item_id:0
                            });

                            // self.fetchBanks();

                        }else{
                            self.$router.push("/bank-transfer/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createReceiptBtn").val("Update");
                        $("#createReceiptBtn").prop("disabled", false);
                        $("#cancelReceiptBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#ReasonForm").trigger("reset");


                            $("#createAndContinueReceiptBtn").val("Save and Continue");
                            $("#createReceiptBtn").prop("disabled", false);
                            $("#createAndContinueReceiptBtn").prop("disabled", false);
                            $("#cancelReceiptBtn").prop("disabled",false);

                        }else{

                            $("#createReceiptBtn").val("Save");
                            $("#createReceiptBtn").prop("disabled", false);
                            $("#createAndContinueReceiptBtn").prop("disabled", false);
                            $("#cancelReceiptBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'reason-create')
                }
            });
      }else{
                self.errorValidationFocus();
      }

    },

    loadReceipt() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/bank-receipt/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    // self.receipt_date = data.content.receipt_date;
                    // self.bank_reference = data.content.reference_no;
                    // self.amount = data.content.amount.toFixed(2)
                    // self.amount_entered = data.content.amount_entered;
                    // self.difference = data.content.difference;
                    // self.account_name = data.content.account_name;
                    // self.payment_number = data.content.payment_no;
                    // self.account_number = data.content.account_number;
                    // self.description = data.content.description;
                    // self.customer_reference = data.content.customer_reference;
                    if (data.content.account_number != null){
                        self.account_number = {text:data.content.account_number,value:data.content.account_number};
                    }
                    if (data.content.type != null){
                        self.type = {text:data.content.typecaps,value:data.content.type};
                    }
                    if(data.content.receipt_number != null){
                        self.receipt_number = data.content.receipt_number;
                    }
                    if (data.content.rec_items.length >=1) {
                        for (var i = 0; i < data.content.rec_items.length; i++) {
                            self.rows.push({
                                item_id:data.content.rec_items[i].id,
                                payment_number:data.content.rec_items[i].payment_no,
                                description:data.content.rec_items[i].description,
                                payment_date:data.content.rec_items[i].receipt_date,
                                payment_number_error_msg:"",
                                customer_reference:data.content.rec_items[i].customer_reference,
                                amount:data.content.rec_items[i].amount.toFixed(2),
                                bank_reference:data.content.rec_items[i].reference_no,
                                receipt_number:data.content.rec_items[i].receipt_number
                            });
                        }
                    }else{
                        self.rows.push({
                                receipt_item_id: 0,
                                payment_number: '',
                                payment_number_error_msg: "",
                                payment_date: null,
                                payment_date_error_msg: "",
                                amount: 0,
                                amount_error_msg:'',
                                bank_reference: "",
                                customer_reference:"",
                                description:"",
                                receipt_number:0,
                                item_id:0
                            });
                    }
                    
                    // self.loadReceiptItems();
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'reason-by-id')
            }
        });
    },

    isNumberKey: function(evt) {

        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
  }
};
</script>
<style scoped>
.right-adjust{
    width: 50%!important;
    float: right;
    height: 38px;
    padding-right: 8px;
    border-bottom: 1px solid !important;
    border-bottom-color: #8080802e !important;
}
.overClass{
    overflow: visible !important;
}

.currencyinput input {
    border: 0;
}

</style>




// WEBPACK FOOTER //
// src/components/ReceiptCreate.vue